module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-bw.0d440566.png";